import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { Status } from "@/validation";
import { required, min } from "@/validation/rules";
import { useI18n } from "vue3-i18n";
import FormInput from "@/components/forms/FormInput.vue";
import Fieldset from "@/components/forms/Fieldset.vue";
import FormCheckbox from "@/components/forms/FormCheckbox.vue";
import FormRow from "@/components/forms/FormRow.vue";
import FormFiles from "@/components/forms/FormFiles.vue";
import {Product} from "@/types/entities/product";
import FormTextEditor from "@/components/forms/FormTextEditor.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductBaseForm',
  props: {
    product: {},
    title: {},
    nameFrLabel: {},
    nameEnLabel: {},
    descriptionFrLabel: {},
    descriptionEnLabel: {}
  },
  emits: ["handleValidation", "registerFormInputRef"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

// eslint-disable-next-line no-undef
const props = __props

// eslint-disable-next-line
const emit = __emit

const product = ref<Product>(props.product)

function addFormInputRef(ref: typeof FormInput) {
    emit("registerFormInputRef", ref);
}

async function onImageChange(event: any, type: string) {
  const file = event?.target?.files[0];
  if (file && type === "card") product.value.cardImage = file as File
}

async function onSavedImageChange(url: string, type: string) {
  if (type === "card") product.value.savedCardImage = url
}

async function handleValidation(name: string, validationStatus: Status) {
    emit("handleValidation", name, validationStatus);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Fieldset, {
      title: props.title
    }, {
      default: _withCtx(() => [
        _createVNode(FormRow, null, {
          default: _withCtx(() => [
            _createVNode(FormFiles, {
              modelValue: product.value.cardImage,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((product.value.cardImage) = $event)),
              name: "cardImage",
              ref: addFormInputRef,
              label: _unref(t)('products.form.image-card'),
              tooltip: _unref(t)(`products.form.image-card-tooltip`),
              possiblesTypes: ['image/png', 'image/jpg', 'image/jpeg', 'image/webp'],
              "default-selected-files": product.value.savedCardImage != null ? [product.value.savedCardImage] : [],
              "can-delete": "",
              onOnDefaultSelectedFilesChange: _cache[1] || (_cache[1] = ($event: any) => (onSavedImageChange($event, 'card'))),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (onImageChange($event, 'card'))),
              onValidated: handleValidation
            }, null, 8, ["modelValue", "label", "tooltip", "default-selected-files"]),
            _renderSlot(_ctx.$slots, "image")
          ]),
          _: 3
        }),
        _renderSlot(_ctx.$slots, "after-images"),
        _createVNode(FormRow, null, {
          default: _withCtx(() => [
            _createVNode(FormInput, {
              modelValue: product.value.nameFr,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((product.value.nameFr) = $event)),
              type: "text",
              name: "name-fr",
              ref: addFormInputRef,
              label: _unref(t)(props.nameFrLabel ?? 'products.form.name-fr'),
              onValidated: handleValidation
            }, null, 8, ["modelValue", "label"]),
            _createVNode(FormInput, {
              modelValue: product.value.nameEn,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((product.value.nameEn) = $event)),
              type: "text",
              name: "name-en",
              ref: addFormInputRef,
              label: _unref(t)(props.nameEnLabel ?? 'products.form.name-en'),
              onValidated: handleValidation
            }, null, 8, ["modelValue", "label"])
          ]),
          _: 1
        }),
        _createVNode(FormTextEditor, {
          modelValue: product.value.descriptionFr,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((product.value.descriptionFr) = $event)),
          ref: addFormInputRef,
          name: "description-fr",
          label: _unref(t)(props.descriptionFrLabel ?? 'products.form.description-fr'),
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label"]),
        _createVNode(FormTextEditor, {
          modelValue: product.value.descriptionEn,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((product.value.descriptionEn) = $event)),
          ref: addFormInputRef,
          name: "description-en",
          label: _unref(t)(props.descriptionEnLabel ?? 'products.form.description-en'),
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label"]),
        _renderSlot(_ctx.$slots, "before-prices")
      ]),
      _: 3
    }, 8, ["title"]),
    _createVNode(Fieldset, {
      title: _unref(t)('products.form.price')
    }, {
      default: _withCtx(() => [
        _createVNode(FormRow, null, {
          default: _withCtx(() => [
            _createVNode(FormInput, {
              type: "number",
              name: "member-price",
              modelValue: product.value.memberPrice,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((product.value.memberPrice) = $event)),
              modelModifiers: { number: true },
              ref: addFormInputRef,
              label: _unref(t)('products.form.memberPrice'),
              rules: [_unref(required), _unref(min)(0)],
              tooltip: _unref(t)('products.form.no-taxes'),
              onValidated: handleValidation
            }, null, 8, ["modelValue", "label", "rules", "tooltip"]),
            (!product.value.membersOnly)
              ? (_openBlock(), _createBlock(FormInput, {
                  key: 0,
                  type: "number",
                  name: "non-member-price",
                  modelValue: product.value.nonMemberPrice,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((product.value.nonMemberPrice) = $event)),
                  modelModifiers: { number: true },
                  ref: addFormInputRef,
                  label: _unref(t)('products.form.nonMemberPrice'),
                  rules: product.value.membersOnly ? [] : [_unref(required), _unref(min)(0)],
                  tooltip: _unref(t)('products.form.no-taxes'),
                  onValidated: handleValidation
                }, null, 8, ["modelValue", "label", "rules", "tooltip"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(FormCheckbox, {
          name: "membersOnly",
          modelValue: product.value.membersOnly,
          "onUpdate:modelValue": [
            _cache[9] || (_cache[9] = ($event: any) => ((product.value.membersOnly) = $event)),
            _cache[10] || (_cache[10] = newValue => {if (newValue) product.value.nonMemberPrice = undefined })
          ],
          ref: addFormInputRef,
          label: _unref(t)('products.form.membersOnly'),
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label"])
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})